import * as React from 'react';
import { components } from 'react-select';
export var Input = function Input(props) {
  return /*#__PURE__*/React.createElement(components.Input, props);
};